module.exports = __webpack_public_path__ + "img/1.aa788e42.png";